namespace RioERP.Masters {
    export interface SmsTemplateVariablesRow {
        Id?: number;
        VariableCode?: string;
        VariableName?: string;
    }

    export namespace SmsTemplateVariablesRow {
        export const idProperty = 'Id';
        export const nameProperty = 'VariableCode';
        export const localTextPrefix = 'Masters.SmsTemplateVariables';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            VariableCode = "VariableCode",
            VariableName = "VariableName"
        }
    }
}
